import { resolveUsers as tenantResolveUsers } from './comments.config'
import type { CommentBody } from '@liveblocks/client'
import { stringifyCommentBody } from '@liveblocks/client'

export const serializeCommentBody = (
  body: CommentBody,
  resolveUsers = tenantResolveUsers,
): Promise<string> => stringifyCommentBody(body, { format: 'plain', resolveUsers })
